export default {
  title: 'New Segmentation',
  title_edit: 'Editing Segmentation',

  bulkEdit: 'Bulk create',
  'bulkEdit.fields.checklistTypes': 'Checklist types',
  'bulkEdit.fields.userGroups': 'User groups',
  'bulkEdit.fields.placeLevels': 'Place levels',
  'bulkEdit.fields.assets': 'Assets',

  'generalStep.title': 'Basic Info',
  'generalStep.subtitle': "Fill the segmentation's info",
  'generalStep.name': 'Name*',
  'generalStep.nameRequired': 'Please add a name',

  'checklistTypes.title': 'Checklist types',
  'checklistTypes.subtitle': 'Select the checklist types that this segmentation is associated with',
  'checklistTypes.selectTypeRequired': 'Select a service type',

  'groupStep.title': 'User groups',
  'groupStep.subtitle': 'Select the user groups that will run this activity',
  'groupStep.selectGroupRequired': 'Select a group',

  'placeLevelStep.title': 'Places',
  'placeLevelStep.subtitle': 'Select the place used on this Activity',

  'assetStep.title': 'Assets',
  'assetStep.subtitle': 'Select the assets used on this Activity',
  'placeLevelStep.title': 'Places/People',
  'placeLevelStep.subtitle': 'Select the places/people used in this activity',
  'placeLevelStep.selectPlaceRequired': 'Select a place',

  'assetStep.title': 'Assets',
  'assetStep.subtitle': 'Select the assets that will be used in this activity',
  'assetStep.validation.selectAsset': 'Select at least one asset',

  'resumeStep.title': 'Summary',
  'resumeStep.subtitle': 'Review the information',

  all: 'All',
  ignoring: 'Ignoring'
}
